import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button } from "antd";
import { GoUnlink } from "react-icons/go";
import { MutationKeys, QueryKeys } from "../../../enums/react-query";
import { unLinkDevice } from "../../../services/devices/devices.service";
import { useAppStore } from "../../../store/store";
import { TCustomerData } from "../../../types/types";
import { initCustomerData } from "../../../utils/constants";

const UnLinkDeviceModal = () => {
  const setModalIsOpen = useAppStore((state) => state.setModalIsOpen);
  const modalData = useAppStore((state) => state.modalData);
  const modalDetails = useAppStore((state) => state.modalDetails);
  const setModalDetails = useAppStore((state) => state.setModalDetails);

  const queryClient = useQueryClient();

  const { mutate: unLinkDeviceMutate, isPending: unLinkDeviceIsPending } =
    useMutation({
      mutationKey: [MutationKeys.UNLINKDEVICE],
      mutationFn: () => unLinkDevice(modalDetails._id, modalData[0]),
      onSuccess: (data) => {
        setModalIsOpen(false);
        setModalDetails(initCustomerData);
        queryClient.invalidateQueries({
          queryKey: [QueryKeys.GETCUSTOMERDEVICES, modalDetails._id],
        });
        queryClient.invalidateQueries({
          queryKey: [QueryKeys.GETCUSTOMERTABLEDATA, modalDetails._id],
        });
        queryClient.invalidateQueries({
          queryKey: [QueryKeys.GETCUSTOMERDATA],
        });
      },
      onError: (error) => {
        // console.log(error);
      },
    });

  return (
    <div className="w-[370px] h-[280px] bg-white rounded-[8px] shadow ">
      <div className="flex flex-col w-full h-full items-center justify-between p-[30px] ">
        <div className="rounded-full bg-brand-yellow h-[59px] w-[59px] flex items-center justify-center ">
          <GoUnlink className="text-[33px] text-brand-darkYellow" />
        </div>
        <div className="flex flex-col items-center justify-center gap-[2px] text-center">
          <h5 className="Nunito font-[500] text-[20px] 2xl:text-[24px] text-[#1E1E1E]">
            UnLink Device
          </h5>
          <p className="Nunito font-[300] text-[13px] 2xl:text-[15px] text-[#6B7280]">
            Are you sure you want to unlink this Device from{" "}
            {(modalDetails as TCustomerData).fullName}?
          </p>
        </div>

        <div className="flex items-center justify-center w-full gap-[10px] ">
          <Button
            type="primary"
            htmlType="button"
            className="Nunito w-full max-w-[95px] h-[30px] flex items-center justify-center bg-[#EFEFEF] hover:!bg-[#EFEFEF] !text-[#6B7280] hover:!text-[#6B7280] hover:opacity-[0.8] font-[500] text-[10px] 2xl:text-[12px] rounded-[8px]  "
            loading={false}
            onClick={() => {
              setModalIsOpen(false);
            }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="button"
            className="Nunito w-full max-w-[95px] h-[30px] flex items-center justify-center bg-brand-darkRed hover:!bg-brand-darkRed !text-white hover:!text-white hover:opacity-[0.8] font-[500] text-[10px] 2xl:text-[12px] rounded-[8px]  "
            loading={unLinkDeviceIsPending}
            onClick={() => {
              unLinkDeviceMutate();
            }}
          >
            UnLink
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UnLinkDeviceModal;
